var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"countdown__item"},[_c('span',[_vm._v("Time Remaining to the next scheduling: "+_vm._s(_vm.remaining.minutes)+":"+_vm._s(_vm.remaining.seconds))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }